// import logo from './logo.svg';
// import './App.css';
import Body from "./Components/Body";

import {
  chain,
  configureChains,
  createClient,
  WagmiConfig,
} from 'wagmi';


import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';



const { provider } = configureChains(
  [chain.goerli],
  
  [
    alchemyProvider({ apiKey: process.env.REACT_APP_Alchemy_APIKEY }),
    publicProvider({ url: process.env.REACT_APP_Infura_API }),
  ])

const wagmiClient = createClient({
  autoConnect: true,
  provider
})


function App() {
  return (
    <WagmiConfig client={wagmiClient}>
      <Body />
    </WagmiConfig>
  );
}

export default App;
